import { render } from "./Pot.vue?vue&type=template&id=690b8d66"
import script from "./Pot.vue?vue&type=script&lang=js"
export * from "./Pot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__